import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_URL } from 'src/app/_common/constants';
import { CommonService } from 'src/app/_services/common.service';
import { PsiData } from 'src/app/_models/psi-data';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private _psiData: PsiData;

  constructor(private http: HttpClient, private commonService: CommonService) { }

  getMessages():Observable<any> {
    return this.http.get<any>(API_URL.Messages, {observe: 'response'})
      .pipe(map(response => {
          console.log("All Messages ");
          if((response.body.result != null && response.body.result.length > 0) || response.body.result != ""){
            this.createMessageStorage(response.body.result);
          }
          return response.body.result;
      }));
  }
  public getStorage(){
    let psiData: PsiData = this.commonService.getData();

    return psiData.messages;
    //Observable<JSON.parse(sessionStorage.getItem('psiData'))>;
  }
  
  public createMessageStorage(data){
    this._psiData = JSON.parse(sessionStorage.getItem('psiData'));
    this._psiData.messages = data;
    this.commonService.storeData(this._psiData);
  }

  public removeMessageStorage(){
    this._psiData = JSON.parse(sessionStorage.getItem('psiData'));
    if(this._psiData.messages){
      this._psiData.messages = null;
    }
    this.commonService.storeData(this._psiData);
  }
}
